import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { Wire, WireTemplate } from '@treasury/domain/wires';
import { TmContainer, TmFooterService } from '@treasury/presentation';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '../../partials/wire-data-readonly';
import { WireAction } from '../../types/wire-workflow-parameters.type';
import './wire-template-readonly';

export const tagName = 'wire-template-confirm-step';
@customElement(tagName)
export class WireTemplateConfirmStep extends TmContainer {
    @InjectProperty()
    declare private readonly footerService: TmFooterService;

    @state()
    private wire: Wire = new Wire();

    @state()
    private wireTemplate: WireTemplate = new WireTemplate();

    @state()
    private action = '' as WireAction;

    protected firstUpdated() {
        this.configureFooter();
    }

    protected render() {
        return this.action === 'initiate' ? this.renderWireData() : this.renderWireTemplateData();
    }

    private configureFooter() {
        this.footerService.configure({
            direction: this.isDesktop ? 'row' : 'column',
            buttonConfig: [
                {
                    text: 'Create another wire',
                    importance: 'secondary',
                    classes: this.action === 'initiate' ? '' : 'hidden',
                    onClick: () => {
                        this.dispatchEvent(new CustomEvent('create-wire'));
                    },
                },
                {
                    text: 'View wire activity',
                    importance: 'secondary',
                    classes: this.action === 'initiate' ? '' : 'hidden',
                    onClick: () => {
                        this.dispatchEvent(new CustomEvent('view-wires'));
                    },
                },
                {
                    text: 'View template list',
                    importance: 'secondary',
                    classes: this.action === 'edit' ? '' : 'hidden',
                    onClick: () => {
                        this.dispatchEvent(new CustomEvent('view-wire-templates'));
                    },
                },
            ],
        });
    }

    private renderWireData() {
        return html`<confirmation-container .headingText=${'Wire Submitted'}>
            <wire-data-readonly
                .wire=${this.wire}
                .wireTemplateName=${this.wireTemplate.name}
                .creditorDetail=${false}
            ></wire-data-readonly>
        </confirmation-container>`;
    }

    private renderWireTemplateData() {
        return html`<confirmation-container .headingText=${'Wire Template Updated'}>
            <wire-template-readonly
                .wireTemplate=${this.wireTemplate}
                .creditorDetail=${false}
            ></wire-template-readonly>
        </confirmation-container>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: WireTemplateConfirmStep;
    }
}
